import React from "react";
import styled from "styled-components";
import { UploadDropZone } from "../UploadDropZone/UploadDropZone";
import { MaterialUploadList, UploadedFile } from "../MaterialUploadList/MaterialUploadList";
import { Typography } from "../../general/Typography";
import { Flex } from "../../layouts/wrappers/Flex";

interface MaterialUploadCardProps {
  files: UploadedFile[];
  onFilesChange: (files: UploadedFile[]) => void;
  title?: string;
  hint?: string;
}

const CardWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md};
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.radii.lg};
  border: 1px dashed ${({ theme }) => theme.colors.border};
  padding: ${({ theme }) => theme.spacing.lg};
  width: 100%;
`;

export const MaterialUploadCard: React.FC<MaterialUploadCardProps> = ({
  files,
  onFilesChange,
  title = "Upload Course Materials",
  hint = "Accepted formats: PDF, DOCX, PPT, MP4",
}) => {
  const handleDrop = (droppedFiles: File[]) => {
    const newFiles: UploadedFile[] = droppedFiles.map((file) => ({
      name: file.name,
      size: file.size,
    }));
    onFilesChange([...files, ...newFiles]);
  };

  const handleRemove = (index: string | number) => {
    onFilesChange(files.filter((_, i) => i !== index));
  };

  return (
    <CardWrapper>
      <Typography variant="body">{title}</Typography>
      <UploadDropZone onDrop={handleDrop} />
      <Typography variant="caption" colorScheme="muted">
        {hint}
      </Typography>
      <MaterialUploadList files={files} onRemove={handleRemove} />
    </CardWrapper>
  );
};